module.exports = "<app-header [drawer]=\"drawer\"></app-header>\r\n<app-drawer-menu #drawer></app-drawer-menu>\r\n"